import { Controller } from "@hotwired/stimulus"

// Toggle a password input between hidden and plain text, swapping the eye icon
// and the toggle button's accessible label.
// Markup: input has target "input"; the eye/eye-off svgs have targets "show"/"hide";
// the toggle button itself has target "button" with data-show-label/data-hide-label.
export default class extends Controller {
  static targets = ["input", "show", "hide", "button"]

  toggle() {
    const reveal = this.inputTarget.type === "password"
    this.inputTarget.type = reveal ? "text" : "password"
    this.showTarget.hidden = reveal
    this.hideTarget.hidden = !reveal
    this.buttonTarget.setAttribute("aria-label", reveal ? this.buttonTarget.dataset.hideLabel : this.buttonTarget.dataset.showLabel)
  }
}
